import { Gym } from '../model/gym';
import options from '../../../src/assets/options.json';

export class GymUtils {
  static INSTAGRAM_USERNAME_REGEX =
    '^(?!\\d+$)(?!.*\\.\\.)(?!\\.)(?!.*\\.$)[a-zA-Z0-9._]{3,30}$';

  public static validateAdditionalInfoForGym = (gym: Gym) => ({
    ...gym,
    additionalInfo: {
      area: gym.additionalInfo?.area ?? null,
      poolLength: gym.additionalInfo?.poolLength ?? null,
      isOnline: gym.additionalInfo?.isOnline ?? null,
    },
  });

  public static isValidInstagramUsername = (text: string) => {
    return text.match(GymUtils.INSTAGRAM_USERNAME_REGEX) === null
      ? false
      : true;
  };

  public static isValidHomePageURL = (text: string) => {
    try {
      new URL(text);

      return true;
    } catch (err) {
      return false;
    }
  };

  public static readonly getOptionsTranslation =
    (
      field:
        | 'activities'
        | 'equipmentsToBring'
        | 'gymEquipments'
        | 'gymInfos'
        | 'gymTypes'
        | 'services'
        | 'geniusFeatures'
    ) =>
    (key: string) =>
      (options[field] as { [key: string]: string })?.[key] || key;

  public static get requirementTypes(): { value: string; label: string }[] {
    return [
      {
        value: 'NONE',
        label:
          'No booking required. Members can come anytime during opening hours.',
      },
      {
        value: 'CLASS_OR_APPOINTMENT',
        label:
          'No booking required for free training or regular gym sessions except for classes or special appointments.',
      },
      { value: 'EVERY_VISIT', label: 'Booking required for every visit.' },
      { value: 'FIRST_VISIT', label: 'Booking required for first visit only.' },
    ];
  }
}
